import { render, staticRenderFns } from "./_Tram2Work.vue?vue&type=template&id=2ccb0077&"
import script from "./_Tram2Work.vue?vue&type=script&lang=js&"
export * from "./_Tram2Work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports